import React, { useState } from 'react';

function ImportDuplicatesModal({ duplicates, onClose, onConfirm }) {
  const [decisions, setDecisions] = useState(
    duplicates.reduce((acc, item, index) => {
      acc[index] = 'skip'; // Default to skip
      return acc;
    }, {})
  );

  const handleDecisionChange = (index, decision) => {
    setDecisions(prev => ({
      ...prev,
      [index]: decision
    }));
  };

  const handleApplyAll = (decision) => {
    const newDecisions = {};
    duplicates.forEach((_, index) => {
      newDecisions[index] = decision;
    });
    setDecisions(newDecisions);
  };

  const handleConfirm = () => {
    const booksToAdd = duplicates
      .filter((_, index) => decisions[index] === 'copy')
      .map(item => item);
    
    onConfirm(booksToAdd);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: '800px', width: '90%', maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}>
        <div className="modal-header">
          <h2>נמצאו ספרים כפולים</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div style={{ padding: '15px', backgroundColor: '#fff3cd', color: '#856404', marginBottom: '15px', borderRadius: '4px' }}>
          נמצאו {duplicates.length} ספרים שכבר קיימים במערכת. אנא בחר כיצד לטפל בהם.
        </div>

        <div style={{ marginBottom: '15px', display: 'flex', gap: '10px' }}>
          <button className="btn btn-sm btn-primary" onClick={() => handleApplyAll('copy')}>הוסף הכל כעותק</button>
          <button className="btn btn-sm btn-secondary" onClick={() => handleApplyAll('skip')}>דלג על הכל</button>
        </div>

        <div style={{ flex: 1, overflowY: 'auto', border: '1px solid #ddd', borderRadius: '4px' }}>
          <table className="data-table" style={{ margin: 0 }}>
            <thead style={{ position: 'sticky', top: 0, backgroundColor: '#f8f9fa', zIndex: 1 }}>
              <tr>
                <th>ספר</th>
                <th>מחבר</th>
                <th>פעולה</th>
              </tr>
            </thead>
            <tbody>
              {duplicates.map((item, index) => (
                <tr key={index} style={{ backgroundColor: decisions[index] === 'copy' ? '#e8f5e9' : '#fff' }}>
                  <td>
                    <div style={{ fontWeight: 'bold' }}>{item.bookName}</div>
                    <div style={{ fontSize: '0.85em', color: '#666' }}>{item.departmentName} {item.categoryName ? ` / ${item.categoryName}` : ''}</div>
                  </td>
                  <td>{item.author}</td>
                  <td>
                    <div style={{ display: 'flex', gap: '15px' }}>
                      <label style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <input
                          type="radio"
                          name={`decision-${index}`}
                          checked={decisions[index] === 'copy'}
                          onChange={() => handleDecisionChange(index, 'copy')}
                        />
                        הוסף כעותק
                      </label>
                      <label style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <input
                          type="radio"
                          name={`decision-${index}`}
                          checked={decisions[index] === 'skip'}
                          onChange={() => handleDecisionChange(index, 'skip')}
                        />
                        דלג
                      </label>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="modal-footer" style={{ marginTop: '15px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
          <button className="btn btn-secondary" onClick={onClose}>ביטול</button>
          <button className="btn btn-success" onClick={handleConfirm}>
            אישור ({Object.values(decisions).filter(d => d === 'copy').length} ספרים להוספה)
          </button>
        </div>
      </div>
    </div>
  );
}

export default ImportDuplicatesModal;
